/**
 * SectionHeader — Cabecera monocromática (B&W) reutilizada en todas las
 * secciones del sistema (Operaciones, HSE, HR, Finanzas, Mantenimiento,
 * Inventario, Campamento, Análisis, SGSSO, etc.). Provee identidad
 * visual homogénea, profesional, sin colores decorativos:
 *   - Bloque negro cuadrado con el ícono en blanco
 *   - Título en peso black, seguido de eyebrow en uppercase gris
 *   - Slot opcional a la derecha para acciones (botones, filtros)
 *
 * Props:
 *   icon       — componente phosphor-icons (obligatorio)
 *   title      — string principal
 *   eyebrow    — subtítulo pequeño en mayúsculas
 *   size       — "lg" (page-level h1) | "md" (module h2, default)
 *   right      — nodo opcional a la derecha
 *   testid     — data-testid del contenedor
 */
export default function SectionHeader({ icon: Icon, title, eyebrow, size = "md", right, testid, className = "" }) {
  const isLg = size === "lg";
  const boxCls = isLg ? "h-11 w-11" : "h-10 w-10";
  const iconSize = isLg ? 22 : 20;
  const titleCls = isLg
    ? "font-heading font-black text-2xl tracking-tight text-slate-900 leading-none"
    : "font-heading font-black text-xl tracking-tight text-slate-900 leading-none";
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid={testid}>
      <div className={`${boxCls} rounded-md bg-slate-900 flex items-center justify-center shadow-sm ring-1 ring-slate-800/40`}>
        <Icon size={iconSize} weight="duotone" className="text-white" />
      </div>
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-0.5">
          {eyebrow || " "}
        </p>
        <h1 className={titleCls}>{title}</h1>
      </div>
      {right && <div className="flex-1 flex justify-end items-center gap-2 ml-auto">{right}</div>}
    </div>
  );
}
